import { render, staticRenderFns } from "./BuffList.vue?vue&type=template&id=62d8ccc8&"
import script from "./BuffList.vue?vue&type=script&lang=ts&"
export * from "./BuffList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports